
import { defineComponent } from "vue";
import SubCatalogueGrid from "@/components/controls/catalogueGrid/SubCatalogueGrid.vue";
import { TableDesignConfig } from "@/components/controls/catalogueGrid/tableDesignConfig";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";
import { TableSelectionConfig } from "@/components/controls/catalogueGrid/tableSelectionConfig";
import { TextColumnConfig } from "@/components/controls/catalogueGrid/columns/textColumnConfig";
import { requiredRule } from "@/components/controls/catalogueGrid/columns/baseValidationRules";
import { CatalogueColumnConfig } from "@/components/controls/catalogueGrid/columns/catalogueColumnConfig";
import planOrderNomenclatureConstraintCreateEditDialog from "@/components/journals/PlanOrderJournal/PlanOrderNomenclatureConstraintCreateEditDialog.vue";
import { TextBooleanDateTimeColumnConfig } from "@/components/controls/catalogueGrid/columns/textBooleanDateTimeColumnConfig";

export default defineComponent({
  components: {
    SubCatalogueGrid,
  },
  props: {
    parentModel: { required: true },
  },
  computed: {
    planOrderNomenclatureConstraintCreateEditDialog: function () {
      return planOrderNomenclatureConstraintCreateEditDialog;
    },
    getChangedConfig() {
      return this.editingConfig;
    },
  },
  data() {
    return {
      columns: [
        new CatalogueColumnConfig({
          dataField: "featureDescription",
          caption: "Свойство",
          modelIdField: "featureId",
          modelDescField: "featureDescription",
          keyField: "id",
          displayField: "featureDescription",
          displayDescField: "name",
          catalogueComponentName:
            "catalogues/FeatureCatalogue/FeatureCatalogue",
          descriptionColumnName: "featureDescription",
          validationRules: [requiredRule],
        }),
        new TextColumnConfig({
          dataField: "typeDescription",
          caption: "Операция",
          validationRules: [requiredRule],
        }),
        new TextBooleanDateTimeColumnConfig({
          dataField: "valueDescription",
          dataFieldBoolean: "valueBoolean",
          dataFieldDateTime: "valueDateTime",
          caption: "Значение",
          dataType: "boolean",
          disabled: true,
        }),
      ],
      selectionConfig: new TableSelectionConfig({
        mode: "single",
        hoverStateEnabled: false,
      }),
      designConfig: new TableDesignConfig({
        popUpColumnsCount: 1,
        popUpWidth: "850px",
        height: "385px",
        pagingMode: "scroll",
        heightScroll: "385px",
        horizontalScroll: false,
      }),
      editingConfig: new TableEditingConfig({
        allowUpdating: true,
        allowAdding: true,
        allowDeleting: true,
        confirmDelete: true,
        allowDataFill: false,
        allowExport: false,
        allowClearFilter: false,
        allowDeleteMultipleRows: false,
      }),
    };
  },
  created() {
    if (this.selectMode) {
      this.editingConfig = this.selectModeEditingConfig;
    }
  },
});
